import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";
import { ArrowRight } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1612632554560-42cc9d2acfdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FCFCFA] flex flex-col">
      {/* Nav */}
      <header className="absolute top-0 inset-x-0 z-30">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
          <Logo variant="light" className="h-16 sm:h-20" />
          <div className="flex items-center gap-3">
            <Link to="/candidatura" data-testid="nav-apply-link" className="hidden sm:inline text-sm text-[#26130E] bg-[#F7EEC7] hover:bg-[#e8dca8] rounded-full px-6 py-2.5 transition-colors font-medium">
              Inscrever-me
            </Link>
            <Link to="/login" data-testid="landing-login-link" className="text-sm text-[#FCFCFA] hover:text-[#F7EEC7] border border-[#FCFCFA]/50 rounded-full px-6 py-2.5 transition-colors backdrop-blur-sm">
              Entrar
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative min-h-screen flex items-end">
        <div className="absolute inset-0">
          <img src={HERO} alt="Porto" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#26130E] via-[#26130E]/55 to-[#26130E]/20" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 sm:px-10 pb-20 lg:pb-28 w-full">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }} className="max-w-3xl">
            <div className="sc-label text-[#F7EEC7] mb-5">Um clube privado no Porto · Só para elas</div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#FCFCFA] leading-[1.05] tracking-tight">
              You haven't met all your friends yet.
            </h1>
            <div className="mt-7 text-lg text-[#FCFCFA]/85 max-w-xl leading-relaxed space-y-4">
              <p>The Social Club nasceu para tornar mais fácil aquilo que, em adultas, se tornou estranhamente difícil: conhecer pessoas novas.</p>
              <p>Uma comunidade privada de mulheres entre os 28 e os 38 anos, no Porto, para novas amizades, bons planos e tudo aquilo que é melhor quando temos com quem partilhar.</p>
            </div>
            <Link to="/candidatura" data-testid="hero-apply-cta" className="inline-flex items-center gap-3 mt-9 bg-[#F7EEC7] hover:bg-[#e8dca8] text-[#26130E] font-medium rounded-full pl-8 pr-6 py-4 transition-colors group">
              Inscrever-me no clube
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
